import { jsx, jsxs } from "react/jsx-runtime";
import { Box } from "braid-design-system";
import { small, container, offsetBasedOnLength, circle, ratingHalf, rating1, rating2, rating3, rating4 } from "./Circles.styles.css.mjs";
const Circles = ({ value, size, align }) => /* @__PURE__ */ jsx(Box, { className: `${size === "small" ? small : ""}`, children: /* @__PURE__ */ jsxs(
  Box,
  {
    className: [
      container,
      align === "center" ? offsetBasedOnLength[Math.ceil(value / 25)] : ""
    ],
    children: [
      value > 0 && /* @__PURE__ */ jsx(
        "div",
        {
          className: `${circle} ${ratingHalf}`,
          style: { opacity: value > 0 ? 1 : 0 }
        }
      ),
      value > 15 && /* @__PURE__ */ jsx(
        "div",
        {
          className: `${circle} ${rating1}`,
          style: { opacity: value > 15 ? 1 : 0 }
        }
      ),
      value > 25 && /* @__PURE__ */ jsx(
        "div",
        {
          className: `${circle} ${rating2}`,
          style: { opacity: value > 25 ? 1 : 0 }
        }
      ),
      value > 50 && /* @__PURE__ */ jsx(
        "div",
        {
          className: `${circle} ${rating3}`,
          style: { opacity: value > 50 ? 1 : 0 }
        }
      ),
      value > 75 && /* @__PURE__ */ jsx(
        "div",
        {
          className: `${circle} ${rating4}`,
          style: { opacity: value > 75 ? 1 : 0 }
        }
      )
    ]
  }
) });
export {
  Circles
};
